import { useQuery } from "react-query";

import { cauHinhBaoCaoNVLApi } from "src/1/apis/cau_hinh_bao_cao_nvl.api";
import { cuaHangApi } from "src/1/apis/cua_hang.api";

export const useGetAllStores = () => {
  const { data = [], isFetching } = useQuery({
    queryKey: ["danh-sach-tat-ca-chi-nhanh"],
    queryFn: () => cuaHangApi.getAll(),
    select: (response) =>
      response?.data?.data?.map((item) => ({
        ...item,
        label: item.name,
        value: item.code,
      })),
  });

  return { stores: data, loading: isFetching };
};

export const useGetMyStores = () => {
  const { data = [], isFetching } = useQuery({
    queryKey: ["danh-sach-tat-ca-chi-nhanh-nhan-vien-phu-trach"],
    queryFn: () => cuaHangApi.getMyStore(),
    select: (response) =>
      response?.data?.data?.map((item) => ({
        ...item,
        label: item.name,
        value: item.code,
      })),
  });

  return { stores: data, loading: isFetching };
};

export const useGetAllReportTypes = () => {
  const { data = [], isFetching } = useQuery({
    queryKey: ["danh-sach-cau-hinh-bao-cao"],
    queryFn: () => cauHinhBaoCaoNVLApi.getAllTypes(),
    select: (response) =>
      response?.data?.data?.map((item) => ({
        code: item?.code,
        value: item?.code,
        label: item?.name,
      })),
  });

  return { types: data, loading: isFetching };
};
